module.exports = __webpack_public_path__ + "img/SES_160250002.167f2c4b.jpg";